import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import NCVTDetails from './section-components/ncvt-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const NcvtCourse = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>National Council Vocational Course in Chennai | NCVT Course</title>
            <meta name="description" content="Best NCV Training in MIET Chennai offers Certification Courses, Diploma Courses and Degree Courses in the IT and Industry." />
        </Helmet>
        <PageHeader headertitle="NCVT Course"  />
        <NCVTDetails />
        <Footer />
    </div>
}

export default NcvtCourse

